import React, { useMemo } from "react";
import styled from "styled-components";
import GeneralEventDetailsTable from "components/events/events/GeneralEventDetailsTable";
import { detailsAttributes } from "components/events/Constants";
import DropdownButton from "components/bootstrap/DropdownButton";
import useEventAction from "components/events/events/hooks/useEventAction";
import TagsDetailRow from "components/events/TagsDetailRow";
const attributesList = detailsAttributes.map(({ id, title }) => ({ id, title }));
const ActionsWrapperContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacings.md};
`;
const ActionsWrapper = ({ children }) => /* @__PURE__ */ React.createElement(ActionsWrapperContainer, null, /* @__PURE__ */ React.createElement(DropdownButton, { title: "Actions", buttonTitle: "Actions" }, children));
const DefaultDetails = ({ event, eventDefinitionContext }) => {
  const { moreActions, pluggableActionModals } = useEventAction(event);
  const meta = useMemo(
    () => ({ context: { event_definitions: { [event.event_definition_id]: eventDefinitionContext } } }),
    [event.event_definition_id, eventDefinitionContext]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GeneralEventDetailsTable, { attributesList, event, meta }), /* @__PURE__ */ React.createElement(TagsDetailRow, { tags: event.tags, interactive: false }), /* @__PURE__ */ React.createElement(ActionsWrapper, null, moreActions), pluggableActionModals);
};
export default DefaultDetails;
